import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/HomeBannerBcg.webp")